// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDZ6CSc23FPXsEfXHSQzflkS_bpaV7sJkQ",
    authDomain: "document-automation-45475.firebaseapp.com",
    projectId: "document-automation-45475",
    storageBucket: "document-automation-45475.firebasestorage.app",
    messagingSenderId: "174636778372",
    appId: "1:174636778372:web:537c4a0705bef25b0613d1",
    measurementId: "G-7KYSMRHNNV"
  };

  const app = initializeApp(firebaseConfig);
  export const auth = getAuth(app);  
